import * as React from "react";

function SvgSpinnakr(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 397 397"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          fill="#1D4F9A"
          d="M249.076 3.149c-35.169 13.523-63.07 36.254-83.579 67.659-9.263 14.183-16.169 29.749-21.579 45.919-9.567 28.592-13.715 58.048-14.431 88.056-.962 40.364 4.346 79.996 14.306 119.061.32 1.255.504 2.545.841 4.274-10.687-1.109-21.091-1.956-31.532-2.061-14.683-.146-29.284.423-43.388 5.177-3.487 1.176-6.818 2.663-9.882 4.699-9 5.979-11.606 13.967-8.076 24.226 3.247 9.437 8.766 17.505 14.882 25.237 1.233 1.559 2.393 3.175 3.586 4.765l-.716.953c-36.977-18.628-60.321-47.618-67.662-88.841-.412-2.313.028-4.939-1.847-6.891v-35c2.547-7.174 2.724-14.818 4.443-22.173 8.496-36.334 24.774-69.036 46.746-98.892C101.148 71.43 166.596 25.452 247.616 1.833c.474-.139.975-.185 1.462-.272l-.002 1.588z"
        />
        <path
          fill="#0195D6"
          d="M231.172 21.547c-28.304 26.549-36.083 60.917-37.369 97.809-.464 13.331.188 26.675 1.464 39.863 1.289 13.309 4.413 26.474 7.242 39.592 6.064 28.121 15.313 55.238 26.23 81.836 4.134 10.073 9.37 19.617 13.453 29.694-15.737 4.533-31.995 6.582-47.962 10.017-11.292 2.43-22.807 3.814-33.881 7.261-7.529-28.896-12.136-58.269-14.363-88.029-1.793-23.973-1.854-47.98 1.127-71.812 6.775-54.145 24.991-102.714 69.788-137.68 4.328-3.378 8.734-6.669 13.625-9.23.203.238.418.465.646.679z"
        />
        <path
          fill="#0195D6"
          d="M220.227 58.797c-2.955 10.966-4.303 21.699-4.205 32.505.268 29.374 6.261 57.838 15.093 85.682 21.593 68.078 53.906 130.551 98.662 186.395 8.131 10.146 16.894 19.732 26.214 28.804.825.803 1.894 1.402 2.093 2.706-1.505.856-2.487-.407-3.574-.967a582.862 582.862 0 00-56.415-25.315c-3.419-1.321-5.918-3.202-7.969-6.246-30.502-45.264-51.714-94.764-66.941-146.96-8.081-27.699-13.658-55.911-14.906-84.807-.983-22.755.629-45.258 8.949-66.803.62-1.607.826-3.528 2.999-4.994z"
        />
        <path
          fill="#1D4F9A"
          d="M160.35 327.619c11.074-3.446 22.589-4.831 33.881-7.261 15.967-3.435 32.225-5.483 47.962-10.017 8.335 15.82 17.102 31.391 27.913 47.428-6.934-2.242-12.61-4.137-18.323-5.915-22.753-7.084-45.728-13.329-69.104-18.013a447.852 447.852 0 00-18.964-3.379c-1.897-.295-3.171-.789-3.365-2.843z"
        />
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgSpinnakr);
